import { createAction } from "redux-actions"
import { GET_QUESTIONNAIRES, SET_QUESTIONNAIRES } from "../names"

export const getQuestionnaires = createAction(GET_QUESTIONNAIRES)
export const setQuestionnaires = createAction(SET_QUESTIONNAIRES)
